export default __webpack_public_path__ + "static/media/solar.2188e1ed.webp";